import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { FullWidth } from '../Misc/FullWidth'

type Props = {
  videoToRender: any
  backgroundColor?: string
}

export const VideoBlockPublic = ({ videoToRender, backgroundColor }: Props) => {
  const [adjustedVideoToRender, setAdjustedVideoToRender] = useState(
    videoToRender
  )
  const [videoHeight, setVideoHeight] = useState(0)

  useEffect(() => {
    const heightRegex = /height=["']?(\d+)["']?/
    const match = videoToRender.match(heightRegex)
    const widthRegex = /width=["']?(\d+)["']?/
    const widthMatch = videoToRender.match(widthRegex)
    let newVideoRatio

    if (match && widthMatch) {
      // get height/width from iframe embed
      const heightValue = match[1]
      const widthValue = widthMatch[1]
      newVideoRatio = parseInt(heightValue) / parseInt(widthValue)

      setVideoHeight(Math.min(378, 672 * newVideoRatio))
      // rewrite iframe width to 672px
      let newVideoToRender = videoToRender.replace(widthRegex, 'width="672px"')
      // rewrite iframe height to max of aspect ratio width or 378px
      newVideoToRender = newVideoToRender.replace(
        heightRegex,
        `height="${Math.max(378, 672 * newVideoRatio)}px"`
      )
      setAdjustedVideoToRender(newVideoToRender)
    }
  }, [videoToRender])

  return adjustedVideoToRender ? (
    <FullWidth backgroundColor={backgroundColor}>
      <VideoDiv
        videoHeight={videoHeight}
        dangerouslySetInnerHTML={{
          __html: adjustedVideoToRender,
        }}
      />
    </FullWidth>
  ) : null
}

const VideoDiv = styled('div')<{ videoHeight?: number }>`
  position: relative;
  max-width: 672px;
  max-height: 378px;
  padding-bottom: ${({ videoHeight }) => `min(56.25%, ${videoHeight}px)`};
  margin: 0 auto;
  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
